import { LOT_LIST } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case LOT_LIST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case LOT_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case LOT_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
